/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".message[_ngcontent-%COMP%]{display:flex;flex-direction:row;font-size:large}.message[_ngcontent-%COMP%]   .success[_ngcontent-%COMP%]{font-size:x-large;color:#007072;padding-right:10px}.message[_ngcontent-%COMP%]   .failure[_ngcontent-%COMP%]{font-size:x-large;color:#f90;padding-right:10px}"];
export { styles as styles };
